import * as React from 'react';
import { IconProps } from './icon-props';

const InfoIcon: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="13"
    fill="none"
    viewBox="0 0 12 13"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 4.98a.463.463 0 0 0 .462-.461v-.462a.462.462 0 1 0-.923 0v.462a.463.463 0 0 0 .462.461M5.077 6.827h.461v2.615a.462.462 0 0 0 .923 0V6.365A.463.463 0 0 0 6 5.904h-.923a.461.461 0 1 0 0 .923"
    ></path>
    <path
      fill="currentColor"
      d="M6 12.75a6 6 0 1 0-6-6 6.006 6.006 0 0 0 6 6M6 1.611A5.139 5.139 0 1 1 6 11.89 5.139 5.139 0 0 1 6 1.61"
    ></path>
  </svg>
);

export default InfoIcon;
